import { TextV2 } from '@withjoy/joykit';
import React from 'react';
import { Content, DesktopImageContainer, DesktopImage, Inner, MobileImage, Section } from './JumbotronSection.styles';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { useTranslation } from '@shared/core';

type JumbotronSectionProps = {
  category: StationeryTemplateCategoryEnum;
};

export const JumbotronSection: React.FC<JumbotronSectionProps> = ({ category }) => {
  const { tq } = useTranslation('stationery');

  if (category !== StationeryTemplateCategoryEnum.saveTheDate) {
    return null;
  }

  return (
    <Section>
      <MobileImage src="https://withjoy.com/assets/public/stationery-hero-save-the-date-mobile.png" />
      <Inner>
        <Content>
          <TextV2
            typographyVariant={['hed6', null, 'display3']}
            textAlign={['center', null, 'left']}
            as="h1"
          >
            {tq`Save the Date Cards`}
          </TextV2>
          <TextV2
            typographyVariant={['body1', null, 'body2']}
            textAlign={['center', null, 'left']}
          >
            {tq`Beautifully designed, unbelievably joyful to send. Every design is available as both an elegant paper card and a convenient digital Save the Date, so you can announce your day, your way.`}
          </TextV2>
        </Content>
        <DesktopImageContainer>
          <DesktopImage src="https://withjoy.com/assets/public/stationery-hero-save-the-date-desktop.png" />
        </DesktopImageContainer>
      </Inner>
    </Section>
  );
};
